/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Open_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This artifact doesn't exist or you don't have access to it." |
*
* @param {Artifact_Open_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_open_not_found_description = /** @type {((inputs?: Artifact_Open_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Open_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Artefakt existiert nicht oder Sie haben keinen Zugriff darauf.")
	return /** @type {LocalizedString} */ ("This artifact doesn't exist or you don't have access to it.")
});